import { __extends } from "tslib";
import { PutBucketCorsRequest } from "../models/index";
import { deserializeAws_restXmlPutBucketCorsCommand, serializeAws_restXmlPutBucketCorsCommand, } from "../protocols/Aws_restXml";
import { getApplyMd5BodyChecksumPlugin } from "@aws-sdk/middleware-apply-body-checksum";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketCorsCommand = /** @class */ (function (_super) {
    __extends(PutBucketCorsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketCorsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketCorsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        this.middlewareStack.use(getApplyMd5BodyChecksumPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutBucketCorsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketCorsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketCorsCommand(input, context);
    };
    PutBucketCorsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketCorsCommand(output, context);
    };
    return PutBucketCorsCommand;
}($Command));
export { PutBucketCorsCommand };
//# sourceMappingURL=PutBucketCorsCommand.js.map